export default "__VITE_PUBLIC_ASSET__89dcec2b__"